import { BookContent, BookContentWithTopic, BookDetail, BookIllustrations, Job, JobStatus, Language } from './types';

const MAX_DELAY = 4 * 60 * 1000; // 4 min
const DELAY = 1000; // 1 sec
const BACKEND_URL = 'https://brakid-bookai-f8ccb4bf3ae9.herokuapp.com';

export const loadJobData = <T>(jobId: string, url: string): Promise<T> => {
  return new Promise((resolve, reject) => {
    const loader = setInterval(async () => {
      console.log('Attempting to load data for job ' + jobId);
      const response = await fetch(url + jobId, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'GET',
        mode: 'cors'
      });
      if (response.status !== 200) {
        clearInterval(loader);
        reject(new Error('Request was not successful: ' + response.status + ' - ' + response.statusText));
      }
      const data = await response.json() as JobStatus<T>;
      if (data.finished && ((!data.success) || data.data === undefined)) {
        clearInterval(loader);
        reject(new Error('Job ' + jobId + ' was not successful: ' + data.error));
      }
      if (data.finished && data.success && data.data) {
        clearInterval(loader);
        resolve(data.data);
      }
    }, DELAY);
    setTimeout(() => {
      clearInterval(loader);
      console.log('Loading job data timed out');
      reject(new Error('Loading data for job ' + jobId + ' timed out after 3 minutes.'));
    }, MAX_DELAY);
  });
};

export const validateToken = async (token: string): Promise<boolean> => {
  const response = await fetch(BACKEND_URL + '/validate-token/' + token, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'GET',
    mode: 'cors',
    credentials: 'include'
  });
  if (response.status !== 200) {
    throw new Error('Request was not successful: ' + response.status + ' - ' + response.statusText);
  }
  const data = await response.json();
  return data;
};

export const retrieveBookContent = async (bookDetail: BookDetail, token: string, language: Language = 'en'): Promise<BookContent> => {
  const jobResponse = await fetch(BACKEND_URL + '/generate-text', {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    body: JSON.stringify({ ...bookDetail, language })
  });
  if (jobResponse.status !== 200) {
    throw new Error('Request was not successful: ' + jobResponse.status + ' - ' + jobResponse.statusText);
  }
  const job = await jobResponse.json() as Job;

  const data = await loadJobData<BookContent>(job.jobId, BACKEND_URL + '/get-text/');
  return data;
};

export const retrieveBookIllustrations = async (bookContent: BookContentWithTopic, token: string, language: Language = 'en'): Promise<BookIllustrations> => {
  const jobResponse = await fetch(BACKEND_URL + '/generate-illustrations', {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    body: JSON.stringify({ ...bookContent, language })
  });
  if (jobResponse.status !== 200) {
    throw new Error('Request was not successful: ' + jobResponse.status + ' - ' + jobResponse.statusText);
  }
  const job = await jobResponse.json() as Job;

  const data = await loadJobData<BookIllustrations>(job.jobId, BACKEND_URL + '/get-illustrations/');
  return data;
};